import {Store} from '@reatom/core'
import {createPrimitiveAtom} from '@reatom/core/primitives'
import {getTime, hoursToMilliseconds} from 'date-fns'
import {indexBy} from 'ramda'
import {getApi} from '../../api'

let lastInitTimestamp: number | null

export interface PriorityData {
  id: string
  title: string
  position: number
  color: string
}

export const itemPrioritiesAtom = createPrimitiveAtom<
  Record<string, PriorityData>
  >({})

export async function updateItemPrioritiesAtom({dispatch}: Store) {
  if (
    lastInitTimestamp &&
    lastInitTimestamp + hoursToMilliseconds(2) > getTime(new Date())
  ) {
    return
  }
  const data = await getApi().procurement.getProcurementPriorityMap()
  const record = indexBy(x => x.id, data)
  dispatch(itemPrioritiesAtom.set(record))
  lastInitTimestamp = getTime(new Date())
  return record
}